module.exports = __webpack_public_path__ + "static/img/index2.31f59c0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index2.gif
// module id = cb7+
// module chunks = 0